import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { screen } from 'components/styles/variables';
import buttonCSS from 'components/styles/button';
// eslint-disable-next-line import/no-cycle
import { mmyUrlFromVehicle } from 'components/Comparison';

function StickyBarVehicle({
  vehicle,
  listingsCount,
}: {
  vehicle: { year?: number | string; make?: string; model?: string };
  listingsCount: number;
}): JSX.Element {
  const { t } = useTranslation();
  return (
    <div>
      <h3>
        {t('comparison.ymm', {
          year: vehicle.year,
          make: vehicle.make,
          model: vehicle.model,
        })}
      </h3>
      <a href={mmyUrlFromVehicle(vehicle)} className="button">
        {t('comparison.listings.viewAll', { count: listingsCount })}
      </a>
      <style jsx>{buttonCSS}</style>
      <style jsx>{`
        div {
          text-align: center;
          width: 50%;
          margin-top: 1em;
          margin-bottom: 1em;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
        }

        .button {
          font-size: 0.8em;
          user-select: none;
          text-align: center;
          display: inline-block;
          background-color: rgb(242, 9, 2);
          color: white;
          font-weight: 600;
          cursor: pointer;
          padding-left: 5%;
          padding-right: 5%;
          padding-top: 5%;
          padding-bottom: 5%;
          text-decoration: none;
          border-width: 0px;
          border-style: initial;
          border-color: initial;
          border-image: initial;
          border-radius: 40px;
          width: 88%;
        }

        h3 {
          margin-top: 2px;
          line-height: 1em;
          font-size: 1.2em;
          margin-bottom: 7px;
        }

        @media (min-width: ${screen.smMin}) {
          div {
            font-size: 1.8em;
          }

          .button {
            font-size: 1.3em;
            padding: 3%;
            width: 55%;
          }

          h3 {
            font-size: 1.5em;
          }
        }
      `}</style>
    </div>
  );
}
StickyBarVehicle.propTypes = {
  vehicle: PropTypes.object,
  listingsCount: PropTypes.number,
};

export default StickyBarVehicle;
